import { render, staticRenderFns } from "./SubUser.vue?vue&type=template&id=2f522e31"
import script from "./SubUser.vue?vue&type=script&lang=js"
export * from "./SubUser.vue?vue&type=script&lang=js"
import style0 from "./SubUser.vue?vue&type=style&index=0&id=2f522e31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports